module.exports = __webpack_public_path__ + "img/hero-image-video.51ab02ef.svg";